import { request } from '../until/axios.js'
// 新增
export function addsysRole(pram) {
  return request({
    url: '/system/sysRole',
    method: 'post',
    data:pram
  })

}
// 修改
export function editsysRole(loginForm) {
  return request({
    url: '/system/sysRole',
    method: 'put',
    data: loginForm
  })

}
// 删除
export function delsysRole(pram) {
  return request({
    url: '/system/sysRole',
    method: 'delete',
    data: pram
  })
}
// 按id查询
export function getsysRole(id) {
  return request({
    url: '/system/sysRole/get/'+id,
    method: 'GET',
    data: {}
  })
}
// 列表查询
export function listsysRole(pram) {
  return request({
    url: '/system/sysRole/list',
    method: 'post',
    data:pram
  })

}
// 分页查询
export function listPagesysRole(pram) {
  return request({
    url: '/system/sysRole/listPage',
    method: 'post',
    data:pram
  })

}




export function getsysUser(id) {
  return request({
    url: '/system/sysUser/listPage',
    method: 'GET',
    data: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/role.js